import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { MemberSearch } from './interfaces/member-search';
import { AddMakeQuickPayment } from './add-make-quick-payment';
import { ScholarshipDetails } from './interfaces/scholarship-details';
import { ClubMemberCounters, ClubMember, map, StorageUtil } from './store';
import { MemberTeamRequest } from './interfaces/member-team-request';
import * as _ from 'lodash';
import { EmailMessageOptions } from './email-mesage-options';
import { HttpService } from './services/http.service';

@Injectable()
export class MemberService {

  private _url = '/api/ClubUserProgramFee';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  getBillingMemberCounts(id: string) {
    return this.http.get<ClubMemberCounters>(this._url + '/get-members-count/' + id);
  }

  getTravelBillingMembers(clubProgramID: number) {
    return this.httpService.get(`${this._url}/travel-clubprogram/${clubProgramID}`);
  }

  getMembers(id: string | number, status: string): Observable<ClubMember[]> {
    return this.http.get<ClubMember[]>(this._url + '/clubprogramr/' + id + '/' + status).pipe(map(res => _.sortBy(res, 'lastName')));
  }

  deleteMembers(member_ids: string) {
    return this.http.delete(this._url + '/delete-members/' + member_ids);
  }

  setMemberToTeam(bodyRequestParameters: MemberTeamRequest) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/set-members-to-team-list-new', bodyRequestParameters, httpOptions);
    //return this.http.post(this._url + '/set-members-to-team-list', bodyRequestParameters, httpOptions);
  }

  getMemberBySearch(memberSearch: MemberSearch) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/clubuserprogramfee', memberSearch, httpOptions);
  }

  saveMakeQuickPayment(addMakeQuickPayment: AddMakeQuickPayment) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/makequickpayment', addMakeQuickPayment, httpOptions);
  }

  sendEmailMessage(clubProgramID: number, clubId: number, userId: number, options: EmailMessageOptions) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post('api/ClubBillingMessage/send-message/' + clubProgramID + '/' + clubId + '/' + userId, options, httpOptions);
  }

  sendEmailToPlayers(data, clubId: number) {
    return this.httpService.post(`api/ClubBillingMessage/send-email-to-players/${clubId}`, data);
  }

  getScholarshipDetails(clubUserProgramFeeID: string): Observable<ScholarshipDetails[]> {
    return this.http.get<ScholarshipDetails[]>(this._url + '/getscholarshipdata/' + clubUserProgramFeeID);
  }

  removeTransaction(paymentID: number) {
    return this.httpService.delete(`${this._url}/transaction-history/${paymentID}`);
  }

  updateTransaction(paymentID: number, data) {
    return this.httpService.put(`${this._url}/transaction-history/${paymentID}`, data);
  }

  getAvailableProgramFees(clubProgramID: number, userID: number) {
    return this.httpService.get(`/api/ClubParent/program-fees-list-available/${clubProgramID}/${userID}`);
  }

  getAvailablePaymentOptions(program_id: number, userId: number) {
    return this.httpService.get(`/api/ClubParent/program-fees-plans-list-available/${program_id}/${userId}`);
  }

  registerPlayerData(data) {
    return this.httpService.post(`/api/ClubMember/register-player-to-program`, data); 
  }

  getWaitListMembers(id: string | number): Observable<any[]> {
    return this.httpService.get(`${this._url}/waitlist-members/${id}`).pipe(map(res => _.sortBy(res, 'lastName')));
  }

  changeStatus(status: number, clubUserProgramFeeIDs: number[]) {
    return this.httpService.put(`${this._url}/update-camps-status/${status}`, clubUserProgramFeeIDs);
  }

  declineMembers(clubProgramID: number, users: number[]) {
    return this.httpService.post(`/api/ClubProgram/decline-tryout-member/${clubProgramID}?updatedBy=${StorageUtil.userID}`, users);
  }

  didNotMakeMembers(clubProgramID: number, users: number[]) {
    return this.httpService.post(`/api/ClubProgram/did-not-make-tryout-member/${clubProgramID}?updatedBy=${StorageUtil.userID}`, users);
  }
}



// WEBPACK FOOTER //
// ./src/app/member.service.ts